export default "__VITE_ASSET__51106cef__"